---
import type { ListItem, Props as $ } from "../lib/types";

export type Props = $<ListItem>;

const { node, index, isInline, ...attrs } = Astro.props;
---

<li {...attrs}><slot /></li>
